import { useMemo } from 'react';
import useTheme from 'branding/theme';
const useTabStyles = ({ isHovered, isFocused, inverted, styles, activeStyles }) => {
    const { typography: { tab: { base, active, hovered }, inverted: invertedTypography }, borders } = useTheme();
    const style = useMemo(() => ({
        ...base,
        ...((isFocused || isHovered) && hovered),
        ...(inverted && { ...invertedTypography }),
        ...styles
    }), [styles, base, hovered, isFocused, isHovered, inverted, invertedTypography]);
    const activeStyle = useMemo(() => ({
        ...active,
        ...activeStyles,
        ...(inverted && { ...invertedTypography, ...borders.variant.inverted })
    }), [activeStyles, active, inverted, invertedTypography, borders]);
    return { style, activeStyle };
};
export default useTabStyles;
//# sourceMappingURL=useTabStyles.js.map